<template>
    <div>
      <b-alert show class="center" variant="warning" v-if="time<12"> The data is updated daily after 12:00.</b-alert>
    <b-card>
        <div>
          <b-row>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0">Total Datas</h4>
            </b-col>
            <b-col sm="6">
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='TRY'">  Total Revenues: {{generalTotal}} ₺ ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='USD'">  Total Revenues: $ {{generalTotal}} ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues' && selectedCurrency==='RUB'">  Total Revenues: {{generalTotal}} ₽ ({{filterDates.length}} days)</h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'impressions'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ecpms'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days)  </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ad_requests'">  Total Ad Requests: {{generalTotal}}K ({{filterDates.length}} days) </h4>
              <h4 id="traffic" class="card-title mb-0" v-else-if="selectedDatas === 'ctrs'">  Avg. {{selectedDatas[0].toUpperCase()}}{{selectedDatas.substring(1)}}: {{generalTotal}}% ({{filterDates.length}} days) </h4>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="3">
              <label for="month1">Datas</label>
             <b-form-select id="month1"  v-model="selectedDatas" :plain="true" :options="dataOptions">
              </b-form-select> 
              <b-form-select id="traffic" class="card-title mb-0" v-if="selectedDatas === 'revenues'" v-model="selectedCurrency" :plain="true" :options="currencyOptions">
              </b-form-select>
            </b-col>
            <b-col sm="3">
              <label for="month1">Services</label>
              <v-select :on-change="change" v-model="optionSelected" :multiple=true :options="vSelectText"></v-select>
            </b-col>
            <b-col sm="3">
              <label for="month1">Sites</label>
              <v-select :on-change="change" v-model="siteSelected" :multiple=true :options="sitesSelected"></v-select>
            </b-col>
          </b-row>
          <div v-if="loaderStatus">
            <loader :loading="loading"></loader>
          </div>
          <div v-if="chartStatus">
            <all-component chartId="main-chart-01" class="chart-wrapper"
              style="height:300px;margin-top:40px;" :renderData=renderCommand height="300" ></all-component>
          </div>
        </div>
      </b-card>
    <b-card>
      <data-table :renderData=renderCommand :selectedSites=siteSelected :selectedServices=optionSelected />
    </b-card>
    </div>
</template>
<script>
  import CardBarChartExample from './dashboard/CardBarChartExample'
  import BarBouncerate from './dashboard/BarBouncerate'
  import JWT from 'jsonwebtoken'
  import loader from 'vue-spinner/src/PulseLoader'
  import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
  import Dateformatter from '../plugins/dateFormatter'
  import AllComponent from './dashboard/MainChartAllSites'
  import {
    parse
  } from 'path'
  import numeral from 'numeral'
  import DataTable from './base/Tables'
  import PieChartUser from '../views/charts/PieChartUser'
  import PieChartPageview from '../views/charts/PieChartPageview'
  import PieChartSession from '../views/charts/PieChartSession'
  import dateFormatter from '../plugins/dateFormatter'
  import PieChartRate from '../views/charts/PieChartRate';
  import format from 'date-fns/format'
  import { store } from '../store'
  export default {
    name: 'MainChartTable',
    props:['set_data','selectedData'],
    components: {
      CardBarChartExample,
      DataTable,
      loader,
      VueHotelDatepicker,
      PieChartUser,
      PieChartPageview,
      PieChartSession,
      PieChartRate,
      AllComponent
    },
    data: function () {
      return {
        isloading: false,
        vSelectText: ['yandex_ads', 'facebook', 'adx', 'relap', 'adform'],
        dataDate: '',
        pageView: 0,
        session: 0,
        users: 0,
        rates:0,
        comUsers:0,
        comPageView:0,
        comSession:0,
        comRates:0,
        coUsers:0,
        coPageView:0,
        coSession:0,
        coRates:0,
        ruUsers:0,
        ruPageView:0,
        ruSession:0,
        ruRates:0,
        renderCommand: 0,
        selectedCurrency: 'TRY',
        optionSelected: ['adx'],
        loading: true,
        chartStatus: false,
        loaderStatus: true,
        loaderOverviews:true,
        pieChartStatus:false,
        minDate: '2018/8/7',
        startDate: '2018/8/7',
        endDate: '',
        selectedDatas: 'revenues',
        totalRevenue: 0,
        sitesSelected: ['onediocom', 'onedioru', 'onedioco'],
        siteSelected: ['onediocom'],
        request: false,
        generalTotal: 0,
        dataOptions:[{text:'Revenue', value:'revenues'},
                {text:'Impression', value:'impressions'},
                {text:'Ecpm',value:'ecpms'},
                {text:'Ad Request',value:'ad_requests'},
                {text:'Ctr',value:'ctrs'}],
        currencyOptions:[{text:'₺ (TL)',value:'TRY'},
                {text:'$ (USD)',value:'USD'},
                {text:'₽ (RUB)',value:'RUB'}],
        filterDates:[],
        dateFormat: 'D MMM',
        newdateFormat:'YYYY-MM-DD',
        dateOne: '',
        dateTwo: '',
        isRevenue:false,
        isImpression:false,
        isEcpm:false,
        isAdRequest:false,
        isCtr:false,
        chart_data:false,
        time:'',
      }
    },
    
    methods: {
      async change(e) {
        let label = this.selected
        let service = this.optionSelected
        let data = await this.selectedDatas
        let site = this.siteSelected
        let currency= this.selectedCurrency
        await this.$store.dispatch('OPTIONS_CHART', {
          label,
          service,
          data,
          site,
          currency        })
        await this.$store.dispatch('SET_SITE_SERVICE',{site,service})
        await this.renderCommand++;
       /*  setTimeout(async () => {
          this.loaderStatus = false
          this.chartStatus = true */
         /*  this.generalTotal = await this.$store.state.generalTotal.toFixed(2) */
          await this.$events.listen('SET_GENERAL_TOTAL_MAIN', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
                await this.$events.listen('SET_DATES_MAIN',dates => {
           this.filterDates=dates
         })
         /*  this.filterDates=await this.$store.state.itemsData.filterDates
        }, 1000); */
      },
    async setChartData(){
      this.chartStatus = await false,
      this.loaderStatus = await true,
      this.pieChartStatus=await false
      this.loaderOverviews=await true
      /* setTimeout(async () => { */
        await this.renderCommand++;
        let label = this.selected
        let service = this.optionSelected
        let data = this.selectedDatas
        let site = this.siteSelected
        let currency= this.selectedCurrency
        await this.$store.dispatch('OPTIONS_CHART', {
          label,
          service,
          data,
          site,
          currency
        })
        /* this.generalTotal = await this.$store.state.generalTotal.toFixed(2)  */
        await this.$events.listen('SET_GENERAL_TOTAL_MAIN', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
      /*   this.filterDates=await this.$store.state.itemsData.filterDates */
      await this.$events.listen('SET_DATES_MAIN',dates => {
           this.filterDates=dates
         })
      this.chartStatus = await true
      this.loaderStatus = await false
      this.pieChartStatus=await true
      this.loaderOverviews=await false

      /* }, 1000); */
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.newdateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.newdateFormat)
      }
      return formattedDates
    },
    set_selected_data(){
      this.selectedDatas=this.selectedData

    },
    change_path(){
      if(this.selectedDatas!==this.selectedData){
        if(this.selectedDatas==="revenues"){
        this.$router.push('/datas/revenue')
      }
      else if(this.selectedDatas==="impressions"){
        this.$router.push('/datas/impression')
      }
      else if(this.selectedDatas==="ecpms"){
        this.$router.push('/datas/ecpm')
      }
      else if(this.selectedDatas==="ctrs"){
        this.$router.push('/datas/ctr')
      }
      else if(this.selectedDatas==="ad_requests"){
        this.$router.push('/datas/ad_request')
      }
      }
      
    }
    }
    ,
    async created() {
      /* this.filterDates=this.$store.state.filterDates */
      this.time=new Date()
      this.time=Number(format(this.time,'H'))
      if(!this.$store.state.selectedSites.length){
        this.siteSelected=['onediocom']
      }
      else{
        this.siteSelected=await this.$store.state.selectedSites
      }
      if(!this.$store.state.optionSelectedService.length){
        this.optionSelected=['adx']
      }
      else{
        this.optionSelected=await this.$store.state.optionSelectedService
      }
      this.selectedDatas= await this.selectedData
      let data=await this.selectedDatas
      let label = await this.selected
      let service = await this.optionSelected
      let site = await this.siteSelected
      let currency= await this.selectedCurrency
      
      await this.$store.dispatch('OPTIONS_CHART', {
        label,
        service,
        data,
        site,
        currency
      })
       /*  if(this.$store.state.request){
          await this.$store.dispatch('MAIN_OVERVIEWS_WEEKLY_DATA')
          await this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
          await this.$store.dispatch('CURRENCY')
 
        } */
        if(!this.$store.state.itemsData['filterDates']){
          await this.$store.dispatch('SET_REQUEST',true)
          await this.$store.dispatch('SET_MAIN_ITEMS_WEEKLY')
          await this.$store.dispatch('CURRENCY')
          await this.$events.fire('SET_DATES_MAIN',this.$store.state.itemsData.filterDates)
        }
        else{
          this.filterDates=await this.$store.state.itemsData.filterDates
        }
        /* this.filterDates=await this.$store.state.itemsData.filterDates */
       /*  this.generalTotal = await this.$store.state.generalTotal */
       await this.$events.listen('SET_GENERAL_TOTAL_MAIN', generalTotal => {
                  this.generalTotal=generalTotal.toFixed(2)
                });
                await this.setChartData()
    },
     async mounted() {
       this.time=new Date()
      this.time=Number(format(this.time,'H'))
      numeral.defaultFormat('0,0');
      /* setTimeout( async() => {
        await this.setChartData()
        }, 2000); */
        /* setTimeout( async() => { */
         /*  this.generalTotal = await this.$store.state.generalTotal.toFixed(2) */
        
        if(!this.filterDates.length){
          await this.$events.listen('SET_DATES_MAIN',dates => {
           this.filterDates=dates
         })
        }
        else{
         this.filterDates=await this.$store.state.itemsData.filterDates
        }
         await this.$events.listen('SET_GENERAL_TOTAL_MAIN', generalTotal => {
                  this.generalTotal= generalTotal.toFixed(2)
                });
        /*   this.filterDates=await this.$store.state.itemsData.filterDates
        },2000); */
         await this.setChartData()
      
    },  
    watch: {
       selectedDatas(nValue, oValue){
        this.change_path()
      },
      selectedCurrency(nValue,oValue){
        this.change()
      },
      set_data(nValue,oValue){
        this.setChartData()
      },
      mutationOption(nValue,oValue){
        this.created()
      }
      /* selectedData(nValue,oValue){
        this.set_selected_data()
      } */
    },
  }
</script>

<style scoped>
  #datepicker-trigger{
    width: 250px;
  }
  .half-left{
    width: 50%;
    float: left;
    text-align:right;
  }
  .half-right{
    width: 50%;
    float: left;
    text-align:left;
  }
  .loader{
    color: '#000000'
    
  }
  .center{
    text-align:center;
  }

</style>